(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(require('@fe/calc')) :
    typeof define === 'function' && define.amd ? define(['@fe/calc'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.calc));
}(this, (function (calc) { 'use strict';

    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    var calc__default = /*#__PURE__*/_interopDefaultLegacy(calc);

    /**
     * 扩展Number对象 实现传统的四舍五入
     * @param len 保留几位小数
     */
    Number.prototype.toFixedNew = function (len) {
        var num = this;
        if (num < 0) {
            num = num * -1;
            return ((Math.round(calc__default['default'].multiply(num, Math.pow(10, len))) / Math.pow(10, len)) * -1).toFixed(len);
        }
        return (Math.round(calc__default['default'].multiply(num, Math.pow(10, len))) / Math.pow(10, len)).toFixed(len);
    };
    /**
     * 扩展Number对象 获取小数位位数
     */
    Number.prototype.countDecimals = function () {
        if (Math.floor(this.valueOf()) === this.valueOf())
            return 0;
        return this.toString().split('.')[1].length || 0;
    };

})));
//# sourceMappingURL=index.js.map
